import TerapieComplicanzeEdit from "./components/TerapieComplicanzeEdit.vue";
import TerapieComplicanzeView from "./components/TerapieComplicanzeView.vue";
import TerapieComplicanzeList from "./components/TerapieComplicanzeList.vue";

export default {
    TerapieComplicanzeEdit,
    TerapieComplicanzeView,
    TerapieComplicanzeList,
};
